// extracted by mini-css-extract-plugin
export var blue = "_43-h";
export var brand = "_43-d";
export var darkGrey = "_43-g";
export var disabled = "_43-6";
export var disabledSubtle = "_43-7";
export var error = "_43-8";
export var green = "_43-i";
export var grey = "_43-f";
export var icon = "_43-0";
export var inherit = "_43-c";
export var lightGrey = "_43-e";
export var orange = "_43-k";
export var pink = "_43-m";
export var primary = "_43-1";
export var purple = "_43-n";
export var quaternary = "_43-4";
export var quinary = "_43-5";
export var red = "_43-l";
export var secondary = "_43-2";
export var success = "_43-b";
export var tertiary = "_43-3";
export var warning = "_43-9";
export var warningSecondary = "_43-a";
export var white = "_43-o";
export var yellow = "_43-j";